'use strict';

const isMobile = require('./modules/util/isMobile');

/**
 * @function
 * @description Initializes the tooltip-content and layout
 */
exports.init = function () {
    // do not initialize tooltips in mobile devices
    if (!isMobile()){
        $(document).tooltip({
            items: '.tooltip',
            content: function () {
                return $(this).find('.tooltip-content').html();
            },
            position: {
                my: 'center bottom',
                at: 'center top-10'
            }
        });
    }
};
